import { useReorderObjectiveAttributes } from '@/api/glow-up/glow-up.hooks';
import { SortableList } from '@/components/ui/sortable-list';
import { ObjectiveAttribute } from '@repo/types/src/glow-up';
import { ObjectiveAttributeCard } from './ObjectiveAttributeCard';

type ObjectiveAttributeListProps = {
  attributes: ObjectiveAttribute[];
  refetch: () => void;
};

export const ObjectiveAttributeList = ({
  attributes,
  refetch,
}: ObjectiveAttributeListProps) => {
  const reorder = useReorderObjectiveAttributes();

  if (!attributes.length) {
    return (
      <p className="text-sm text-muted-foreground">
        Aucun attribut d'objectif pour le moment.
      </p>
    );
  }

  return (
    <SortableList
      items={attributes}
      renderItem={(attribute) => (
        <div className="flex flex-wrap gap-4 py-1">
          <ObjectiveAttributeCard attribute={attribute} refetch={refetch} />
        </div>
      )}
      onReorder={(items) => reorder.mutate(items)}
    />
  );
};
